import React, { useState } from 'react'
import Calendar from 'react-calendar'
import { useDispatch, batch } from 'react-redux'

import NumberInput from '../components/NumberInput'
import { useUrlParams } from '../hooks'
import { showSidebar } from '../slices/ui'

import {
  useLastSelectedAccomodationAvailability,
  setAccommodationAvailability
} from '../slices/accommodation'

import {
  CHECK_AVAILABILITY,
  CHECK_IN_DATE,
  GUESTS,
  GUEST_DETAILS,
  NIGTHS
} from '../trans'

import settings from '../conf'

const AccommodationsAvailabilityControl = (props) => {
  const { trail_id, route_id } = useUrlParams(['trail_id', 'route_id'])
  const availability = useLastSelectedAccomodationAvailability() || {}
  const dispatch = useDispatch()
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const lastDate = availability.date

  if (availability?.date && availability?.route_id === route_id && availability?.trail_id !== trail_id) {
    lastDate.setDate(lastDate.getDate() + (trail_id - availability.trail_id))
  }

  const [guest, setGuest] = useState(availability.guest || 1)
  const [date, setDate] = useState()
  const [nigth, setNigth] = useState(availability.nigth || 1)
  const minDate = new Date(today)
  const maxDate = new Date(today)
  const selectDate = date || lastDate || today
  maxDate.setDate(minDate.getDate() + 390)

  if (selectDate < today) {
    selectDate.setDate(today.getDate())
  }

  function handleClick () {
    window.scrollTo(0, 0)
    const availability = {
      date: selectDate,
      guest: guest,
      nigth: nigth,
      route_id: route_id,
      trail_id: trail_id
    }
    batch(() => {
      dispatch(setAccommodationAvailability(availability))
      dispatch(showSidebar(null))
    })
    setDate(null)
  }

  return (
    <form>

      <fieldset className="sidebar__fieldset">
        <legend>{CHECK_IN_DATE}</legend>
        <Calendar className="secondary"
                  locale={settings.LANGUAGE}
                  minDetail="year"
                  value={selectDate}
                  default={selectDate}
                  showNeighboringMonth={false}
                  onChange={setDate}
                  minDate={minDate}
                  maxDate={maxDate}/>
      </fieldset>

      <fieldset className="sidebar__fieldset">
        <legend>{GUEST_DETAILS}</legend>
        <label className="sidebar__numberinput">
          <span>{GUESTS}</span>
          <NumberInput value={guest} onChange={setGuest} />
        </label>
        <label className="sidebar__numberinput">
          <span>{NIGTHS} </span>
          <NumberInput value={nigth} onChange={setNigth} />
        </label>
      </fieldset>

      <button type="button" className="button positive pwa__footer_button" onClick={handleClick}>
        { CHECK_AVAILABILITY }
      </button>

    </form>
  )
}

export default AccommodationsAvailabilityControl
